/* Content data copied from the one-pager source (logic script + markup). */

export interface NavDef {
  name: string;
  d: string[];
}

export const NAV: NavDef[] = [
  { name: 'Dashboard', d: ['M3 10.5 12 4l9 6.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z'] },
  { name: 'Students', d: ['M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2', 'M9.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'] },
  { name: 'Academics', d: ['M12 4 2 9l10 5 10-5z', 'M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5'] },
  { name: 'Communication', d: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'] },
  { name: 'Fees', d: ['M2.5 6.5h19v11h-19z', 'M2.5 10.5h19'] },
  { name: 'Marketing', d: ['M3 11v2a1 1 0 0 0 1 1h3l5 4V6L7 10H4a1 1 0 0 0-1 1z', 'M17 9a4 4 0 0 1 0 6'] },
  { name: 'Website', d: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18'] },
  { name: 'AI Assistant', d: ['M5 8h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2z', 'M12 4v4M9 13h.01M15 13h.01'] },
  { name: 'Reports', d: ['M7 16V9M12 16V5M17 16v-4', 'M3 20h18'] },
];

export interface TileDef {
  v: string;
  k: string;
  bg: string;
  c: string;
  d: string[];
}

export const TILES: TileDef[] = [
  { v: '1,248', k: 'Students', bg: '#EFF6FF', c: '#2563EB', d: ['M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2', 'M9.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'] },
  { v: '95%', k: 'Attendance', bg: '#ECFDF3', c: '#16A34A', d: ['M3 17l5-5 4 3 8-8', 'M16 7h5v5'] },
  { v: '₹12.4L', k: 'Fees Collected', bg: '#FFF8E8', c: '#EA8C1A', d: ['M2.5 6.5h19v11h-19z', 'M2.5 10.5h19'] },
  { v: '28', k: 'New Enquiries', bg: '#EFF6FF', c: '#2563EB', d: ['M3.5 6.5h17v11h-17z', 'm3.5 7 8.5 6 8.5-6'] },
];

export interface ActDef {
  t: string;
  w: string;
}

export const ACTS: ActDef[] = [
  { t: 'New admission enquiry', w: '10 mins ago' },
  { t: 'Fee payment received', w: '25 mins ago' },
  { t: 'Website visitor from Google', w: '1 hour ago' },
  { t: 'Lesson plan generated', w: '2 hours ago' },
  { t: 'Marketing campaign sent', w: '3 hours ago' },
];

export interface FeatureCircle {
  cx: number;
  cy: number;
  r: number;
}

export interface FeatureDef {
  title: string;
  desc: string;
  tileBg: string;
  stroke: string;
  paths: string[];
  circles?: FeatureCircle[];
}

export const FEATURES: FeatureDef[] = [
  {
    title: 'Your AI Workforce',
    desc: '30+ AI agents that plan, decide and act across your school — 24/7/365.',
    tileBg: '#E8F0FE',
    stroke: '#2563EB',
    paths: [
      'M12 3.2l1.9 4.3 4.6.5-3.4 3.1.9 4.6-4-2.3-4 2.3.9-4.6-3.4-3.1 4.6-.5z',
      'M18.6 17.6l.6 1.5 1.6.2-1.2 1 .3 1.6-1.3-.8-1.4.8.4-1.6-1.2-1 1.6-.2z',
    ],
  },
  {
    title: '5-km Market Scan',
    desc: 'See every school you compete with — and where you actually stand.',
    tileBg: '#E8F0FE',
    stroke: '#2563EB',
    paths: ['M12 21s-7-4.9-7-10a7 7 0 1 1 14 0c0 5.1-7 10-7 10z'],
    circles: [{ cx: 12, cy: 11, r: 2.4 }],
  },
  {
    title: '3-Year Success Roadmap',
    desc: 'A free 3-year plan, regenerated every month from real results.',
    tileBg: '#E7F8EF',
    stroke: '#16A34A',
    paths: ['M3 17l5-5 4 3 8-8', 'M16 7h5v5'],
  },
  {
    title: '24/7 Admissions Counsellor',
    desc: 'Answers every parent instantly, in their own language.',
    tileBg: '#EEF0FE',
    stroke: '#6366F1',
    paths: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z', 'M8 9h8M8 13h5'],
  },
  {
    title: 'Digital Marketing',
    desc: 'A converting website plus 184 automated posts a year.',
    tileBg: '#FEF3E4',
    stroke: '#EA8C1A',
    paths: ['M3 11v2a1 1 0 0 0 1 1h3l5 4V6L7 10H4a1 1 0 0 0-1 1z', 'M17 9a4 4 0 0 1 0 6'],
  },
  {
    title: 'AI Teachers',
    desc: 'Lesson plans, homework help and exam prep, curriculum-aligned.',
    tileBg: '#E8F0FE',
    stroke: '#2563EB',
    paths: [
      'M4 19V6a2 2 0 0 1 2-2h5v15H6a2 2 0 0 0-2 2z',
      'M20 19V6a2 2 0 0 0-2-2h-5v15h5a2 2 0 0 1 2 2z',
    ],
  },
  {
    title: 'Parent Assist',
    desc: 'Marks, attendance, PTMs and fees in one simple parent app.',
    tileBg: '#FCE9F3',
    stroke: '#DB2777',
    paths: [
      'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
      'M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
    ],
    circles: [{ cx: 9, cy: 7, r: 4 }],
  },
  {
    title: 'Monthly Optimisation',
    desc: 'Your AI reviews every function monthly, then rewrites the plan.',
    tileBg: '#E5F7F4',
    stroke: '#0D9488',
    paths: ['M7 16V9M12 16V5M17 16v-4', 'M3 20h18'],
  },
];

export interface StatDef {
  value: string;
  label: string;
}

export const STATS: StatDef[] = [
  { value: '2x', label: 'Admissions ambition in 3 years' },
  { value: '30+', label: 'AI roles working for you' },
  { value: '₹0', label: 'Platform cost, always' },
  { value: '24/7', label: 'Never misses a parent' },
];

export const NAV_LINKS = [
  { label: 'Home', href: '#top' },
  { label: 'Features', href: '#features' },
  { label: 'Benefits', href: '#benefits' },
  { label: 'Contact', href: '#contact' },
];

export const ROLES = ['School Owner', 'Founder', 'Principal', 'Director', 'Trustee', 'Management', 'Other'];
export const BOARDS = ['CBSE', 'ICSE', 'State Board', 'IB', 'Cambridge', 'Other'];
export const SIZES = ['Under 500', '500–1,000', '1,000–2,000', '2,000–5,000', '5,000+'];
export const HELP = [
  'Admissions',
  'Marketing',
  'AI Teachers',
  'Parent Engagement',
  'Operations',
  'Fee Collection',
  'Automation',
  'New School',
  'Full AI Ecosystem',
  'Other',
];

export interface LegalSection {
  h: string;
  p: string[];
}

export interface LegalDoc {
  title: string;
  intro: string;
  secs: LegalSection[];
}

export const LEGAL: Record<'terms' | 'privacy', LegalDoc> = {
  terms: {
    title: 'Terms & Conditions',
    intro: 'SOOMUCH Smart Solutions Private Limited · Effective 10-10-2024',
    secs: [
      {
        h: 'Acceptance',
        p: [
          '“We”, “us” and “soomuch.ai” mean SOOMUCH Smart Solutions Private Limited; “you” means the user or subscriber. By accessing or using our website or services, you agree to these Terms. If you do not agree, do not use our services.',
        ],
      },
      {
        h: 'Our services',
        p: [
          'Digital solutions for educational institutions that improve operations and communication — including AUTO CONNECT, SOCIAL HUB, Parental Insight, Auto Fee Hub and AI-Powered Management Hub. We aim for high quality but cannot guarantee specific results.',
        ],
      },
      {
        h: 'Your responsibilities',
        p: [
          'Provide accurate, up-to-date information, including at registration. Use the services lawfully and only in compliance with applicable laws — never for fraudulent or illegal activity. Do not misuse the services, interfere with how they work, or harm the services or other users.',
        ],
      },
      {
        h: 'Account security',
        p: [
          'You are responsible for keeping your account credentials confidential and for all activity under your account. Tell us immediately about any unauthorised use.',
        ],
      },
      {
        h: 'Payments & refunds',
        p: [
          'Subscription fees are payable in advance. We may change fees with prior notice. Because these are digital services, no refunds are given once a service has been accessed for more than 15 days.',
        ],
      },
      {
        h: 'Intellectual property',
        p: [
          'All content, data and materials — including text, graphics, logos, trademarks and software — belong to soomuch.ai or its licensors and are protected by copyright and other IP laws. You may not reproduce, distribute or create derivative works without our explicit permission.',
        ],
      },
      {
        h: 'Service availability',
        p: [
          'We do not guarantee error-free or uninterrupted service, and may modify or discontinue any service with or without notice.',
        ],
      },
      {
        h: 'Limitation of liability',
        p: [
          'To the fullest extent permitted by law, soomuch.ai is not liable for any direct, indirect, incidental, special, consequential or punitive damages arising from your use of, or inability to use, our services.',
        ],
      },
      {
        h: 'Indemnity',
        p: [
          'You agree to indemnify and hold harmless soomuch.ai, its affiliates and their officers, directors and employees against any claims, losses, liabilities, damages, costs or expenses (including reasonable attorneys’ fees) arising from your use of the services or breach of these Terms.',
        ],
      },
      {
        h: 'Suspension & termination',
        p: [
          'We may suspend or terminate your access immediately, without prior notice or liability, for any reason — including a breach of these Terms.',
        ],
      },
      {
        h: 'Changes to these Terms',
        p: [
          'We may modify these Terms at any time; changes take effect when posted. Continuing to use the services means you accept the updated Terms.',
        ],
      },
      {
        h: 'Governing law',
        p: [
          'These Terms are governed by the laws of India, without regard to conflict-of-law provisions. Disputes are subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana, India.',
        ],
      },
      {
        h: 'Entire agreement',
        p: [
          'These Terms are the entire agreement between you and soomuch.ai about your use of the services and replace any prior agreements.',
        ],
      },
      { h: 'Contact', p: ['Questions about these Terms: support@soomuch.ai'] },
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    intro: 'SOOMUCH Smart Solutions Private Limited · Includes our Cookies Policy',
    secs: [
      {
        h: 'Information we collect',
        p: [
          'When you register: your name, email address and contact details. Some app features collect additional data, described under Bus location and Social Hub below.',
        ],
      },
      {
        h: 'How we use it',
        p: ['To provide and improve our services, and to contact you about service updates and promotional offers.'],
      },
      {
        h: 'Sharing',
        p: ['We do not sell, trade or otherwise transfer your personally identifiable information to outside parties without your consent.'],
      },
      {
        h: 'Security',
        p: [
          'We use stringent security measures to protect your information. No internet use is risk-free, so absolute security cannot be guaranteed.',
        ],
      },
      {
        h: 'Cookies',
        p: [
          'We use cookies to distinguish you from other users, improve your browsing experience and understand site traffic and interactions.',
          'Essential cookies run the website. Analytical/performance cookies count visitors and show how they move around the site. Functionality cookies recognise you when you return.',
          'You can control, disable or delete cookies in your browser settings (guidance at aboutcookies.org). Some parts of the site may not work without them.',
        ],
      },
      {
        h: 'Bus location (Driver accounts)',
        p: [
          'For users logged in with the “Driver” role, the app collects real-time device location to show the school bus’s current position, its estimated arrival at stops, and its distance from places such as home or school.',
          'This data is processed securely within the app and shown only to authorised parents/guardians and school staff linked to that bus route. It is never shared with third-party advertisers or used for unrelated purposes.',
          'Collection requires the driver’s explicit consent. Location can be turned off in device settings at any time, which stops the tracking and notification features.',
        ],
      },
      {
        h: 'Social Hub',
        p: [
          'When you connect social media accounts (e.g. Facebook, Instagram, YouTube) to post Event content, we store only what each platform’s API requires — access tokens, usernames and the permissions you grant, such as posting. We never store your passwords or other unnecessary personal information.',
          'This data is used solely to post content and manage your connected accounts, is not shared with any third party, and is stored encrypted.',
          'It is kept only while the account stays registered. Deregistering deletes it from our systems immediately — use “Update Details” under Social Hub → Link Profiles. Re-registering collects fresh data under this policy. You can update or remove connected accounts at any time.',
        ],
      },
      {
        h: 'Changes to this policy',
        p: [
          'We may update this policy, including the Cookies Policy, at any time by posting the new version on our website. Significant changes to Social Hub are also notified through app updates or other appropriate means.',
        ],
      },
    ],
  },
};
